import { send } from "./send"
import hermes from "hermes"
// import { store } from "../basket/index"

export const add = () => {
  const buttonAddArray = Array.from(document.querySelectorAll("button[data-productid]"))
  buttonAddArray.map(button => {
    button.addEventListener("click", () => {
      send(button.dataset.productid, button.dataset.productquantity, "add").then(res => {
        // button.disabled = true
        // button.innerHTML = `${button.dataset.messagealreadyadd}`
        changeButton(button)
        hermes.send("updateBasket", { count: res.basket.items.length, action: "add" }, true)
        basket.store.dispatch.basket.getCart()
      })
    })
  })
}

/**
 * Return HTML Element
 *
 * @param {HTMLElement} selector - Selector
 */
const changeButton = button => {
  button.style.height = `${button.offsetHeight}px`
  button.innerHTML = `<p>${button.dataset.messagealreadyadd}</p>`
  setTimeout(() => {
    button.style.height = ""
    button.innerHTML = `<p>${button.dataset.message}</p>`
  }, 1500)
}
